import styles from "./HighlightText.module.scss";
import { splitHighlights } from "./searchHighlight";

export interface HighlightTextProps {
  text?: string | null;
  searchText?: string | null;
}

export function HighlightText({ text, searchText }: HighlightTextProps) {
  if (!searchText?.trim() || !text) return <span>{text}</span>;

  return (
    <span>
      {splitHighlights(text, searchText).map((part, index) => {
        if (part.type === "exact") {
          return (
            <span key={index} className={styles.fullMatch}>
              {part.text}
            </span>
          );
        }
        if (part.type === "partial") {
          return (
            <span key={index} className={styles.partialMatch}>
              {part.text}
            </span>
          );
        }
        return part.text;
      })}
    </span>
  );
}
